<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addNewOrderModal"
        persistent
        max-width="900px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">New order</span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeAddNewOrderModal(), $validator.reset()"
                  class="close"
                >
                  &nbsp;X</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                Item ordered successfully
              </v-alert>
              <v-alert
                type="error"
                :value="checkURL"
              >
                URL format not acceptable
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex xs12>
                  <branch-select v-model="makeOrderData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="loggedInUserData.is_staff"
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    item-value="value"
                    v-model="makeOrderData.customer_id_fk"
                    :error-messages="errors.collect('customer_id_fk')"
                    data-vv-name="customer_id_fk"
                    label="Customer*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Product Name*"
                    v-model="makeOrderData.product_name"
                    :error-messages="errors.collect('product_name')"
                    v-validate="'required'"
                    data-vv-name="product_name"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Product url*"
                    v-model="makeOrderData.product_url"
                    :error-messages="errors.collect('product_url')"
                    v-validate="'required'"
                    data-vv-name="product_url"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Quantity*"
                    v-model="makeOrderData.quantity"
                    :error-messages="errors.collect('quantity')"
                    v-validate="'required|numeric|min_value:1'"
                    data-vv-name="quantity"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="warehouses"
                    item-value="value"
                    v-model="makeOrderData.warehouse_id_fk"
                    :error-messages="errors.collect('warehouse_id_fk')"
                    data-vv-name="warehouse_id_fk"
                    label="Warehouse*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Type"
                    v-model="makeOrderData.type"
                    data-vv-name="type"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Size"
                    v-model="makeOrderData.size"
                    data-vv-name="size"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Color"
                    v-model="makeOrderData.color"
                    data-vv-name="color"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Coupon"
                    v-model="makeOrderData.coupon"
                    data-vv-name="coupon"
                  ></v-text-field>
                  <span
                    v-if="notCouponCode"
                    style="color: red"
                  >This field must contain a Coupon Code</span>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                >
                  <v-text-field
                    label="Note"
                    v-model="makeOrderData.note"
                    data-vv-name="note"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <!--<div>-->
              <!--<h5 class="lead">-->
              <!--</h5>  -->
              <!--</div>-->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeAddNewOrderModal(), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >Add</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
  <!-- c_o_d -->
</template>
<script>
export default {
  created() {
    this.getLoggedInUser()
  },

  props: [
    'addNewOrderModal',
    'warehouses',
    'closeAddNewOrderModal',
    'checkAlert',
    'deliveryTypes',
    'makeOrderData',
    'makeNewOrder',
    'customers',
    'checkURL',
    'loading'
  ],

  data() {
    return {
      loggedInUserData: {},
      notCouponCode: false
    }
  },

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.makeOrderData.coupon !== '') {
            if (this.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              this.notCouponCode = false
              this.makeNewOrder()
            } else {
              this.notCouponCode = true
            }
          } else {
            this.notCouponCode = false
            this.makeNewOrder()
          }
        }
      })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addNewOrder.vue